export var SecurityListViewInOption;
(function (SecurityListViewInOption) {
    SecurityListViewInOption["VIEW_IN_STOCK_SCREENER"] = "view_in_stock_screener";
    SecurityListViewInOption["VIEW_IN_FUND_SCREENER"] = "view_in_fund_screener";
    SecurityListViewInOption["VIEW_IN_COMP_TABLES"] = "view_in_comp_tables";
    SecurityListViewInOption["VIEW_IN_TIMESERIES"] = "view_in_timeseries";
    SecurityListViewInOption["VIEW_IN_NEWS"] = "view_in_news";
    SecurityListViewInOption["VIEW_IN_TECH_CHART"] = "view_in_technical_chart";
    SecurityListViewInOption["VIEW_IN_FUND_CHART"] = "view_in_fund_chart";
    SecurityListViewInOption["VIEW_IN_SCATTER_PLOT"] = "view_in_scatter_plot";
})(SecurityListViewInOption || (SecurityListViewInOption = {}));
export var IndicatorListViewInOption;
(function (IndicatorListViewInOption) {
    IndicatorListViewInOption["VIEW_IN_TIMESERIES"] = "view_in_timeseries";
    IndicatorListViewInOption["VIEW_IN_FUND_CHART"] = "view_in_fund_chart";
})(IndicatorListViewInOption || (IndicatorListViewInOption = {}));
